import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

/* Store overall app tags(e.g. (#raised_amount#)) mostly from api */
const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {
		setTags(tags, { payload }) {
			return { ...tags, ...payload }
		},
	},
})

export const { setTags } = tagsSlice.actions

export default tagsSlice.reducer
